// extracted by mini-css-extract-plugin
export default {"sortBlock":"mineTypeFilter_sortBlock__TAI70","sortIcon":"mineTypeFilter_sortIcon__vmJNj","option":"mineTypeFilter_option__bqpwj"};